import { render, staticRenderFns } from "./VolunteerCongratsDialog.vue?vue&type=template&id=8e71b5e8&scoped=true"
import script from "./VolunteerCongratsDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerCongratsDialog.vue?vue&type=script&lang=js"
import style0 from "./VolunteerCongratsDialog.vue?vue&type=style&index=0&id=8e71b5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e71b5e8",
  null
  
)

export default component.exports